import React from "react";
import { NavLink } from "react-router-dom";
import { FaInstagram, FaFacebookF, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Global from "../util/Global";

const Footer = () => {
  const { t, i18n } = useTranslation();
  return (
    <footer className="footer widget-footer ttm-bgcolor-darkgrey ttm-textcolor-white clearfix">
      <div className="second-footer" style={{ backgroundColor: "#3f2414" }}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
              <div className="widget widget_text clearfix">
                <div className="footer-logo">
                  <div className="row">
                    <div className="col-xl-6">
                      <img
                        id="logo-img"
                        className="img-fluid auto_size"
                        src={require("../assets/FrontOffice/images/techoney.png")}
                        alt="logo-img"
                      />
                    </div>
                    {/* <div className="col-xl-6">
                      <h3 style={{ marginTop: "33%", marginLeft: "-27%" }}>
                        Nostorm Mare
                      </h3>
                    </div> */}
                  </div>
                </div>
                <div className="textwidget widget-text">
                  <p>
                    {t("footer1.1")}
                  </p>
                </div>
              </div>
            </div>






            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">

              <div className="widget widget_nav_menu clearfix">
                <h3 className="widget-title">{t("footer2.1")}</h3>
                <ul id="menu-footer-quick-links" className="menu">

                  <li>
                    <NavLink to="#">
                      {t("footer3.1")}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="#">
                      {t("footer4.1")}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="#">
                      {t("footer5.1")}
                    </NavLink>
                  </li>

                </ul>
              </div>
            </div>






            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">

              <div className="widget widget_nav_menu clearfix">
                <h3 className="widget-title">Techoney</h3>
                <ul id="menu-footer-quick-links" className="menu">

                  <li>
                    <NavLink to="#">
                      {t("footer6.1")}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="#">
                      {t("footer7.1")}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="#">
                      {t("footer8.1")}
                    </NavLink>
                  </li>


                  <li>
                    <NavLink to="#">
                      {t("footer9.1")}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="#">
                      {t("footer10.1")}
                    </NavLink>
                  </li>

                </ul>
              </div>
            </div>


            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
              <div className="widget widget_cta clearfix">
                <h3 className="widget-title">{t("footer11.1")} </h3>


                <div className="d-inline-table align-items-center justify-content-between">

                  <div className="social-icons d-inline-block margin_top10 margin_bottom10">
                    <ul className="social-icons list-inline">
                      <li><a className="tooltip-top" href={Global.facebookLink} rel="noopener" ><FaFacebookF color="#fff" size="20" /></a></li>
                      <li><a className="tooltip-top" href={Global.instagramLink} rel="noopener" ><FaInstagram color="#fff" size="20" /></a></li>
                      <li><a className="tooltip-top" href={Global.youtubeLink} rel="noopener" ><FaYoutube color="#fff" size="20" /></a></li>
                      <li><a className="tooltip-top" href={Global.linkedinLink} rel="noopener" ><FaLinkedinIn color="#fff" size="20" /></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>






          </div>
        </div>
        <div className="bottom-footer-text copyright" style={{ borderTopWidth: 1, borderTopColor: "#fff" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="d-md-flex justify-content-between">

                  <span className="cpy-text">
                    {t("footer12.1")}
                    <a
                      href="#"
                      className="ttm-textcolor-skincolor font-weight-500"
                    >
                      {" "}Techoney {" "}
                    </a>
                    {t("footer13.1")}
                  </span>
                  <ul className="footer-nav-menu">
                    <li><a href="#">{t("footer14.1")}</a></li>
                    <li><a href="#">{t("footer15.1")} </a></li>
                    <li><a href="#">{t("footer16.1")}</a></li>
                    <li><a href="#">{t("footer17.1")}</a></li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
